import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { Metiers } from "./components/Metiers";
import { About } from "./components/About";
import { Manager } from "./components/Manager";
import { PolesServices } from "./components/PolesServices";
import { Clients } from "./components/Clients";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";
import { Toaster } from "./components/ui/sonner";

// Admin components
import { Login } from "./components/admin/Login";
import { Dashboard } from "./components/admin/Dashboard";
import { QuotesManager } from "./components/admin/QuotesManager";
import { RevenueTracker } from "./components/admin/RevenueTracker";
import { BlogManager } from "./components/admin/BlogManager";
import { ChangePassword } from "./components/admin/ChangePassword";
import { ProtectedRoute } from "./components/admin/ProtectedRoute";

// Public blog components
import { BlogList } from "./components/public/BlogList";
import { BlogDetail } from "./components/public/BlogDetail";

const Home = () => {
  return (
    <div>
      <Helmet>
        <title>AGIPLUS CI | BTP, Mécanique, Hydraulique & Location de Matériel en Côte d'Ivoire</title>
        <meta
          name="description"
          content="AGIPLUS CI accompagne les entreprises du BTP, de l'industrie et de l'énergie : génie civil, terrassement, construction, mécanique, hydraulique, réparation de vérins et location de matériel à Abidjan, Côte d'Ivoire."
        />
        <meta
          name="keywords"
          content="BTP Côte d'Ivoire, Génie civil Abidjan, Terrassement Côte d'Ivoire, Construction Côte d'Ivoire, Mécanique générale, Réparation mécanique, Vérins hydrauliques, Réparation de vérins, Usinage mécanique, Tournage mécanique, Flexibles hydrauliques, Hydraulique Côte d'Ivoire, Maintenance mécanique, Maintenance d'équipements, Location de matériel BTP, Location d'engins Abidjan, Location de matériel industriel"
        />
        <meta property="og:title" content="AGIPLUS CI | BTP, Mécanique, Hydraulique & Location de Matériel" />
        <meta property="og:description" content="Offre intégrée de génie civil, mécanique, hydraulique et location de matériel en Côte d'Ivoire." />
        <meta property="og:type" content="website" />
      </Helmet>
      <Header />
      <Hero />
      <Metiers />
      <About />
      <Manager />
      <PolesServices />
      <Clients />
      <Contact />
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Public routes */}
          <Route path="/" element={<Home />} />
          <Route path="/actualites" element={<BlogList />} />
          <Route path="/actualites/:slug" element={<BlogDetail />} />

          {/* Admin routes */}
          <Route path="/admin/login" element={<Login />} />
          <Route
            path="/admin/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/quotes"
            element={
              <ProtectedRoute>
                <QuotesManager />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/revenue"
            element={
              <ProtectedRoute>
                <RevenueTracker />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/blog"
            element={
              <ProtectedRoute>
                <BlogManager />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/change-password"
            element={
              <ProtectedRoute>
                <ChangePassword />
              </ProtectedRoute>
            }
          />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
